import { render } from "./Home.vue?vue&type=template&id=65241b11&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=65241b11&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-65241b11"

export default script